<template>
<div class="view-immidiate-or-schedule-dashboard-email-list">
<div class="container-fluid">
  <div class="table-responsive margin-Top-6Perc" v-if="getScheduledDashboardEmailList.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">GCC</th>
          <th class="text-align-center font-size-15px border-right">Comment</th>
          <th class="text-align-center font-size-15px border-right">State</th>
          <th class="text-align-center font-size-15px border-right">Frequency</th>
          <th class="text-align-center font-size-15px border-right">Scheduled For</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="currScheduledDashboardEmailObj in getScheduledDashboardEmailList" :key="currScheduledDashboardEmailObj.ReportingTaskId" :currScheduledDashboardEmailObj="currScheduledDashboardEmailObj">
          <td class="border-right text-align-left col-lg-4 col-md-4 border-right" v-html="getGCCInfo(currScheduledDashboardEmailObj)"></td>
          <td class="border-right text-align-center col-lg-2 col-md-2 border-right">{{currScheduledDashboardEmailObj.Description}}</td>
          <td class="border-right text-align-center col-lg-1 col-md-1 border-right">{{getStateValue(currScheduledDashboardEmailObj.State)}}</td>
          <td class="border-right text-align-center col-lg-1 col-md-1 border-right">{{getEmailFrequency(currScheduledDashboardEmailObj.Frequency)}}</td>
          <td class="text-align-center col-lg-2 col-md-2 border-right">{{formatAndShowDate(currScheduledDashboardEmailObj.StartTS) + ' - ' + formatAndShowDate(currScheduledDashboardEmailObj.EndTS)}}</td>
          <td class="text-align-center col-lg-2 col-md-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'edit', currScheduledDashboardEmailObj)"> Edit </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'view', currScheduledDashboardEmailObj)"> View </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', currScheduledDashboardEmailObj)"> Delete </a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <update-schedule-dashboard-email v-if="openEditOverlay" :currSelectedObj="currSelectedObj" :groupCourseCohortList="groupCourseCohortListValue" @emittedValue="updateEmittedValue"></update-schedule-dashboard-email>
  <view-schedule-dashboard-email v-if="openViewOverlay" :currSelectedObj="currSelectedObj" :groupCourseCohortList="groupCourseCohortListValue" @emittedValue="updateEmittedValue"></view-schedule-dashboard-email>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteScheduledDashboardEmail"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import { emailService } from '@/server-util/email-service'
import UpdateScheduleDashboardEmail from '@/components/emails/dashboard_emails/UpdateScheduleDashboardEmail'
import ViewScheduleDashboardEmail from '@/components/emails/dashboard_emails//ViewScheduleDashboardEmail'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import { constants } from '../../../utils/constants'
import { find, forEach } from 'lodash'
export default {
  props: ['scheduledDashboardEmailList', 'groupCourseCohortList'],
  computed: {
    getScheduledDashboardEmailList: {
      get: function () {
        return this.scheduledDashboardEmailList
      }
    },
    groupCourseCohortListValue: {
      get: function () {
        return this.groupCourseCohortList
      },
      set: function (newValue) {
        this.groupCourseCohortList = newValue
      }
    }
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedObj: null,
      openEditOverlay: false,
      openViewOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: ''
    }
  },
  name: 'view-immidiate-or-schedule-dashboard-email-list',
  methods: {
    getGCCInfo: function (currObj) {
      var valueToReturn = 'Loading...'
      if (this.groupCourseCohortListValue.length > 0) {
        const foundObj = find(this.groupCourseCohortListValue, (obj) => {
          return obj.GroupId === currObj.GroupData.GroupId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          valueToReturn = '<span>' + foundObj.GroupName + '</span><br/>'
          const gccData = currObj.GroupData.GCCData
          forEach(gccData, (currObj, index) => {
            const courseObj = find(foundObj.CourseCohortRecord, (currCourseObj) => {
              return currObj.GroupCourseMasterId === currCourseObj.GroupCourseMasterId
            })
            if (courseObj !== undefined && courseObj !== 'undefined' && courseObj !== null && courseObj !== 'null' && courseObj !== '') {
              valueToReturn += '<span style="padding-left:15px !important;">' + (index + 1) + '. ' + courseObj.CourseTitle + ' [' + courseObj.CourseSubTitle + ']'
            }
            const cohortObj = find(courseObj.CohortData, (currCohortObj) => {
              return currObj.CohortIds === currCohortObj.CohortId
            })
            if (cohortObj !== undefined && cohortObj !== 'undefined' && cohortObj !== null && cohortObj !== 'null' && cohortObj !== '') {
              valueToReturn += ' - ' + cohortObj.CohortName
            }
            valueToReturn += ((gccData.length - 1) === (index)) ? '</span>' : '</span><br/>'
          })
        }
      }
      return valueToReturn
    },
    getStateValue: function (state) {
      var valueToReturn = 'Not Found'
      switch (parseInt(state)) {
        default:
          break
        case constants.ReportTaskState.NotStarted:
          valueToReturn = 'Not Started'
          break
        case constants.ReportTaskState.Running:
          valueToReturn = 'Running'
          break
        case constants.ReportTaskState.Scheduled:
          valueToReturn = 'Scheduled'
          break
        case constants.ReportTaskState.Error:
          valueToReturn = 'Error'
          break
        case constants.ReportTaskState.Completed:
          valueToReturn = 'Completed'
          break
      }
      return valueToReturn
    },
    getEmailFrequency: function (frequency) {
      var valueToReturn = 'Not Found'
      switch (parseInt(frequency)) {
        default:
        case constants.ReportingTaskFrequency.None:
          break
        case constants.ReportingTaskFrequency.Immediate:
          valueToReturn = 'Immediate'
          break
        case constants.ReportingTaskFrequency.Daily:
          valueToReturn = 'Daily'
          break
        case constants.ReportingTaskFrequency.Weekly:
          valueToReturn = 'Weekly'
          break
        case constants.ReportingTaskFrequency.Monthly:
          valueToReturn = 'Monthly'
          break
      }
      return valueToReturn
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      this.currSelectedObj = null
    },
    updateEmittedValue (recievedObj) {
      this.openEditOverlay = !recievedObj.closeOverlay
      this.openViewOverlay = !recievedObj.closeOverlay
      this.$store.state.isOverlayVisible = false
      if (recievedObj.refreshRecords) {
        this.$emit('refreshRecords', true)
      }
    },
    performClickOperation: function (event, operationName, selectedObj) {
      this.currSelectedObj = selectedObj
      switch (operationName) {
        case 'edit':
          this.openEditOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'view':
          this.openViewOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete below scheduled task? <br/>'
          this.postString = '"<i>' + this.getGCCInfo(selectedObj) + '"</i>'
          break
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    deleteScheduledDashboardEmail (value) {
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        if (
          this.currSelectedObj.ReportingTaskId !== undefined &&
          this.currSelectedObj.ReportingTaskId !== null
        ) {
          this.$store.state.isLoading = true
          emailService
            .deleteScheduledDashboardEmail(
              storeObj.state.access_token,
              this.currSelectedObj.ReportingTaskId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  this.checkAndDeleteFromMasterScheduledDashboardEmailList()
                  this.$store.state.isLoading = false
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  this.$store.state.isLoading = false
                }
              },
              errorObj => {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = errorObj.response.data.statusText
              }
            )
        } else {
          console.log(
            'ReportingTaskId is NULL hence declined DELETE SCHEDULE DASHBOARD EMAIL Operation'
          )
        }
      }
    },
    checkAndDeleteFromMasterScheduledDashboardEmailList: function () {
      var foundIndex = findIndex(this.scheduledDashboardEmailList, (obj) => {
        return obj.ReportingTaskId === this.currSelectedObj.ReportingTaskId
      })
      // console.log('Delete Index: ' + foundIndex)
      if (foundIndex > -1) {
        this.scheduledDashboardEmailList.splice(foundIndex, 1)
      }
      foundIndex = findIndex(this.$store.state.scheduledDashboardEmailList, (obj) => {
        return obj.ReportingTaskId === this.currSelectedObj.ReportingTaskId
      })
      if (foundIndex > -1) {
        this.$store.state.scheduledDashboardEmailList.splice(foundIndex, 1)
      }
      this.$emit('updatedList', this.scheduledDashboardEmailList)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'update-schedule-dashboard-email': UpdateScheduleDashboardEmail,
    'view-schedule-dashboard-email': ViewScheduleDashboardEmail,
    'confirmation-alert': ConfirmationOverlay
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.view-immidiate-or-schedule-dashboard-email-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/emails/dashboard_emails/ViewImmidiateOrScheduleDashboardEmailList.vue